import { render } from "./WordsList.vue?vue&type=template&id=0c62ef22&scoped=true&ts=true"
import script from "./WordsList.vue?vue&type=script&lang=ts"
export * from "./WordsList.vue?vue&type=script&lang=ts"

import "./WordsList.vue?vue&type=style&index=0&id=0c62ef22&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c62ef22"]])

export default __exports__